import { styled } from '@mui/material/styles';

const OutlinedTag = styled('b')(() => ({
  border: '1px solid #d4d2d0',
  padding: '4px 8px',
  borderRadius: '8px',
  fontSize: '14px',
  fontWeight: 500,
}));

export default OutlinedTag;
